import { flatMap } from 'lib/utilities';

export const getFlattenedOptions = (options) => flatMap(options, (option) => option.options || [option]);
